import axios from "axios";

const token = localStorage.getItem('@agroReceita-Token');

let common = token
  ? {
      Authorization: `Bearer ${token}`,
      apiKey: process.env.REACT_APP_API_KEY,
    }
  : {
      apiKey: process.env.REACT_APP_API_KEY,
    };

const api = axios.create({
  baseURL: process.env.REACT_APP_API_HOST, // rota de desenvolvimento
  headers: common,
});

const DEDUPE_TTL_MS = 1500;
const DEDUPE_ALLOWLIST = new Set([
  "POST /produtores/pesquisa",
  "POST /agronomos/pesquisa",
]);

const stableStringify = (value) => {
  if (value === undefined) return "undefined";
  if (value === null) return "null";
  if (typeof value !== "object") return JSON.stringify(value);
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(",")}]`;
  }
  const keys = Object.keys(value).sort();
  return `{${keys
    .map((k) => `${JSON.stringify(k)}:${stableStringify(value[k])}`)
    .join(",")}}`;
};

const createDeferred = () => {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
};

const inFlight = new Map();
const recent = new Map();

const getDedupeKey = (config) => {
  const method = (config?.method || "GET").toUpperCase();
  const url = config?.url || "";
  const path = url.split("?")[0];

  if (!DEDUPE_ALLOWLIST.has(`${method} ${path}`)) return null;

  const paramsKey = stableStringify(config?.params);
  const dataKey = stableStringify(config?.data);
  return `${method} ${url} params=${paramsKey} data=${dataKey}`;
};

const defaultAdapter = api.defaults.adapter;

api.interceptors.request.use((config) => {
  const key = getDedupeKey(config);
  if (!key || !defaultAdapter) return config;

  const now = Date.now();
  const cached = recent.get(key);
  if (cached && now - cached.ts < DEDUPE_TTL_MS) {
    config.adapter = () => Promise.resolve(cached.response);
    return config;
  }

  const existing = inFlight.get(key);
  if (existing) {
    config.adapter = () => existing;
    return config;
  }

  const deferred = createDeferred();
  inFlight.set(key, deferred.promise);

  const adapter = config.adapter || defaultAdapter;
  config.adapter = (cfg) => {
    adapter(cfg)
      .then((response) => {
        recent.set(key, { ts: Date.now(), response });
        deferred.resolve(response);
      })
      .catch((error) => {
        deferred.reject(error);
      })
      .finally(() => {
        inFlight.delete(key);
      });

    return deferred.promise;
  };

  return config;
});

api.interceptors.response.use(
  (response) => response, // Se a resposta for bem-sucedida, retorna normalmente
  (error) => {
    if (error.response && error.response.status === 401) {
      // Remove o token inválido
      localStorage.removeItem('@userinfo');
      localStorage.removeItem('@impersonacao');

      // Redireciona para a tela de login
      if (window.location.pathname !== '/login') {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
